import { registerBrick, Process } from 'olympe';
import { ReactBrick, useProperty } from '@olympeio/core';
import React from 'react';

import Assessment from '../../../models/Assessment';

import { Button } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import ClearIcon from '@mui/icons-material/Clear';
import CachedIcon from '@mui/icons-material/Cached';

import '../../../../res/stylesheets/assessmentListRenderer.scss';

export default class AssessmentListRenderer extends ReactBrick {
    /**
     * @override
     */
    setupExecution($) {
        return Process.isOnline($);
    }

    static getReactComponent($) {
        return (props) => {
            const [isOnline] = props.values;
            const assessment = useProperty($, 'assessment');
            const downloadedDate = useProperty($, 'date from local storage');
            const isAssessmentSavedForOffline = useProperty($, 'Is Assessment saved for offline');

            const isShowDownloadBtn = isOnline && isAssessmentSavedForOffline;

            if (!assessment) {
                return null;
            }

            return (
                <div className='container'>
                    <div
                        className='content'
                        onClick={() => $.trigger('selected')}>
                        <span className='text'>{assessment.get(Assessment.titleProp)}</span>
                        <span className='text region'>
                            {assessment.get(Assessment.regionProp)} - {assessment.get(Assessment.countryProp)} - {assessment.get(Assessment.provinceProp)}
                        </span>
                    </div>
                    <div className='right-box'>
                        <div className='actions'>
                            <Button
                                variant='text'
                                className={!isShowDownloadBtn ? 'btn btn-hide' : 'btn'}
                                onClick={() => $.trigger('update')}>
                                <CachedIcon />
                            </Button>
                            <Button
                                variant='text'
                                className={!isOnline || isAssessmentSavedForOffline ? 'btn btn-hide' : 'btn'}
                                onClick={() => $.trigger('download')}>
                                <DownloadIcon />
                            </Button>
                            <Button
                                variant='text'
                                className={!isShowDownloadBtn ? 'btn btn-hide' : 'btn'}
                                onClick={() => $.trigger('clear')}>
                                <ClearIcon />
                            </Button>
                        </div>
                        {downloadedDate && <span className='date'>{downloadedDate}</span>}
                    </div>
                </div>
            );
        };
    }
}

registerBrick('018c1ac1e8f12a6c9246', AssessmentListRenderer);
